import "core-js/modules/es.array.filter";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { State } from 'vuex-class';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import AppTextField from '@/components/AppTextField.vue';
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue';
import AppSearchBtn from '@/components/AppSearchBtn.vue';
import AppSimpleTextField from '@/components/AppSimpleTextField.vue';
import { showErrors, showNotification } from '@/utils/snack';
import { utcDateTimeToLocal } from '@/utils/dateTime';
import ListPage from '@/mixins/list-page';
import { exportProfitSharingsList, findProfitSharings } from './gql';
import { ProfitSharingsFindOrdersBy } from '@/interfaces/profitSharing';
import { ProfitSharingStatusText } from '@/helpers/profitSharing';
import { formatCurrency } from '@/utils/currency';
import { SnackType } from '@/interfaces/snack';
import { downloadBase64 } from '@/helpers/base64-to-file';

var ProfitSharingsList = /*#__PURE__*/function (_mixins) {
  _inherits(ProfitSharingsList, _mixins);

  var _super = _createSuper(ProfitSharingsList);

  function ProfitSharingsList() {
    var _this;

    _classCallCheck(this, ProfitSharingsList);

    _this = _super.apply(this, arguments);
    _this.breadcrumbs = [{
      text: '订单管理管理'
    }, {
      text: '佣金管理'
    }];
    _this.options = {
      sortBy: ['createdAt'],
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    };
    _this.utcDateTimeToLocal = utcDateTimeToLocal;
    _this.formatCurrency = formatCurrency;
    _this.ProfitSharingStatusText = ProfitSharingStatusText;
    _this.filter = {
      profitSharingNumber: null,
      orderNumber_OF_order: null
    };
    _this.totalNum = 0;
    _this.loading = false;
    _this.headers = [{
      text: '佣金编号',
      value: 'profitSharingNumber',
      width: 120,
      sortable: false
    }, {
      text: '佣金创建时间',
      value: 'createdAt'
    }, {
      text: '佣金成功时间',
      value: 'timeEnd',
      sortable: false
    }, {
      text: '佣金状态',
      value: 'status',
      width: 120,
      sortable: false
    }, {
      text: '佣金金额',
      value: 'totalPrice'
    }, {
      text: '订单号',
      value: 'orderNumber',
      sortable: false
    }, {
      text: '订单金额',
      value: 'orderPrice',
      sortable: false
    }, {
      text: '订单时间',
      value: 'orderCreatedAt',
      sortable: false
    }, {
      text: '经销商姓名',
      value: 'dealerName',
      sortable: false
    }, {
      text: '经销商电话',
      value: 'dealerPhone',
      sortable: false
    }];
    _this.windowSize = {
      w: 0,
      h: 0
    };
    _this.actionsHeight = 51;
    _this.profitSharings = [];
    return _this;
  }

  _createClass(ProfitSharingsList, [{
    key: "usingStatus",
    value: function usingStatus(status) {
      return {
        'u-tag-blue': status === 'TO_BE_SHARING',
        'u-tag-red': status === 'CHANGE',
        'u-tag-orange': status === 'PROCESSING',
        'u-tag-green': status === 'SUCCESS'
      };
    }
  }, {
    key: "onOptionsChanged",
    value: function onOptionsChanged() {
      this.getProfitSharings();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.onResize();
      this.restorePage(this.cache);
      this.getProfitSharings();
    }
  }, {
    key: "getProfitSharings",
    value: function () {
      var _getProfitSharings = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$options, sortBy, page, itemsPerPage, sortDesc, _this$filter, profitSharingNumber, orderNumber_OF_order, by, asc, order, paging, where, result;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$options = this.options, sortBy = _this$options.sortBy, page = _this$options.page, itemsPerPage = _this$options.itemsPerPage, sortDesc = _this$options.sortDesc;
                _this$filter = this.filter, profitSharingNumber = _this$filter.profitSharingNumber, orderNumber_OF_order = _this$filter.orderNumber_OF_order;
                by = ProfitSharingsFindOrdersBy[sortBy[0] || 'createdAt'];
                asc = !sortDesc[0] || false;
                this.loading = true;
                order = {
                  by: by,
                  asc: asc
                };
                paging = {
                  skip: itemsPerPage * (page - 1),
                  take: itemsPerPage * page
                };
                where = {
                  orderNumber_OF_order: orderNumber_OF_order || null,
                  profitSharingNumber: profitSharingNumber
                };
                _context.next = 10;
                return this.queryProfitSharings(order, paging, where);

              case 10:
                result = _context.sent;

                if (result) {
                  this.profitSharings = result.profitSharings;
                  this.totalNum = result.paging.totalCount;
                }

                this.loading = false;
                this.storePage();

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getProfitSharings() {
        return _getProfitSharings.apply(this, arguments);
      }

      return getProfitSharings;
    }()
  }, {
    key: "queryProfitSharings",
    value: function () {
      var _queryProfitSharings = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(order, paging, where) {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.$apollo.query({
                  query: findProfitSharings,
                  variables: {
                    order: order,
                    paging: paging,
                    where: where
                  }
                });

              case 3:
                result = _context2.sent;
                return _context2.abrupt("return", result.data.findProfitSharings);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                typedError = _context2.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function queryProfitSharings(_x, _x2, _x3) {
        return _queryProfitSharings.apply(this, arguments);
      }

      return queryProfitSharings;
    }()
  }, {
    key: "filterQuerySubmit",
    value: function filterQuerySubmit() {
      this.getProfitSharings();
    }
  }, {
    key: "refreshList",
    value: function refreshList() {
      this.filter = {
        profitSharingNumber: null,
        orderNumber_OF_order: null
      };
      this.getProfitSharings();
    }
  }, {
    key: "onResize",
    value: function onResize() {
      this.windowSize = {
        w: window.innerWidth,
        h: window.innerHeight
      };
      var actionDom = this.$refs.actions;
      this.actionsHeight = actionDom.clientHeight;
    }
  }, {
    key: "exportHandler",
    value: function () {
      var _exportHandler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this$options2, sortBy, sortDesc, _this$filter2, orderNumber_OF_order, profitSharingNumber, by, asc, order, where, result, _result$data$exportPr, fileName, contentB64, typedError;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                showNotification({
                  msg: '即将开始下载...',
                  type: SnackType.Info
                });
                _this$options2 = this.options, sortBy = _this$options2.sortBy, sortDesc = _this$options2.sortDesc;
                _this$filter2 = this.filter, orderNumber_OF_order = _this$filter2.orderNumber_OF_order, profitSharingNumber = _this$filter2.profitSharingNumber;
                by = ProfitSharingsFindOrdersBy[sortBy[0] || 'createdAt'];
                asc = !sortDesc[0] || false;
                this.loading = true;
                order = {
                  by: by,
                  asc: asc
                };
                where = {
                  orderNumber_OF_order: orderNumber_OF_order || null,
                  profitSharingNumber: profitSharingNumber || null
                };
                _context3.prev = 8;
                _context3.next = 11;
                return this.$apollo.query({
                  query: exportProfitSharingsList,
                  variables: {
                    order: order,
                    where: where
                  }
                });

              case 11:
                result = _context3.sent;

                if (result.data) {
                  _result$data$exportPr = result.data.exportProfitSharingsList, fileName = _result$data$exportPr.fileName, contentB64 = _result$data$exportPr.contentB64;
                  downloadBase64(contentB64, fileName);
                }

                this.loading = false;
                _context3.next = 20;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3["catch"](8);
                typedError = _context3.t0;
                showErrors(typedError.graphQLErrors);

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[8, 16]]);
      }));

      function exportHandler() {
        return _exportHandler.apply(this, arguments);
      }

      return exportHandler;
    }()
  }]);

  return ProfitSharingsList;
}(mixins(ListPage));

__decorate([State(function (state) {
  return state.page.OrderList;
})], ProfitSharingsList.prototype, "cache", void 0);

__decorate([Watch('options', {
  deep: true
})], ProfitSharingsList.prototype, "onOptionsChanged", null);

ProfitSharingsList = __decorate([Component({
  components: {
    AppBreadcrumbs: AppBreadcrumbs,
    AppRefreshAndExport: AppRefreshAndExport,
    AppSimpleTextField: AppSimpleTextField,
    AppSearchBtn: AppSearchBtn,
    AppTextField: AppTextField
  }
})], ProfitSharingsList);
export default ProfitSharingsList;